import type { RouteSheetForm } from '@railroute/contracts/rail';
import {
  FORM_CODE,
  FORM_COLUMN_GROUPS,
  FORM_SUBCOLUMNS,
  FORM_TITLE,
  formCells,
  formFooter,
  formHeader,
  UNAPPROVED_MARK,
} from './form';

// Бланк ФРУ № 12 — для печати и сохранения в PDF из окна печати браузера
// (ADR-008 §9, issue #510). Графы и тексты ячеек — из `form.ts`, того же
// места, откуда берёт их выгрузка в Excel.
//
// Неутверждённый лист (решение владельца по PR #593) несёт пометку «Не
// утверждён к оплате»: в шапке бланка, строкой в шапке таблицы (браузер
// повторяет её на каждой странице) и полосой, закреплённой на каждой
// печатной странице.

export function RouteSheetFormSheet({ form }: { form: RouteSheetForm }) {
  const header = formHeader(form);
  const [approval, ...details] = header;
  const unapproved = !form.approvedForPayment;
  return (
    <div className={unapproved ? 'fru12 fru12--unapproved' : 'fru12'}>
      {unapproved ? (
        <>
          <p className="fru12__unapproved" role="note">
            {UNAPPROVED_MARK}
          </p>
          <p className="fru12__unapproved-page print-only" aria-hidden="true">
            {UNAPPROVED_MARK}
          </p>
        </>
      ) : null}
      <p className="fru12__approval">
        <strong>{approval[0]}:</strong> {approval[1]}
      </p>
      <p className="fru12__code">{FORM_CODE}</p>
      <h3 className="fru12__title">{FORM_TITLE}</h3>
      <dl className="fru12__head">
        {details.map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
      <table className="fru12__lines">
        <thead>
          {unapproved ? (
            <tr>
              <th className="fru12__unapproved-row" colSpan={FORM_SUBCOLUMNS.length}>
                {UNAPPROVED_MARK}
              </th>
            </tr>
          ) : null}
          <tr>
            {FORM_COLUMN_GROUPS.map((group) => (
              <th key={group.title} colSpan={group.span} rowSpan={group.span === 1 ? 2 : 1}>
                {group.title}
              </th>
            ))}
          </tr>
          <tr>
            {FORM_SUBCOLUMNS.map((title, index) =>
              title ? <th key={index}>{title}</th> : null,
            )}
          </tr>
        </thead>
        <tbody>
          {form.lines.length === 0 ? (
            <tr>
              <td colSpan={FORM_SUBCOLUMNS.length}>Переездов в листе нет.</td>
            </tr>
          ) : (
            form.lines.map((line) => (
              <tr key={line.sequence}>
                {formCells(line).map((value, column) => (
                  <td key={column}>{value}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <dl className="fru12__foot">
        {formFooter(form).map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
